import makeStyles from '@material-ui/core/styles/makeStyles';
import HelpComp from 'pub-components/Sidebar/helpComp';
import Logo from 'pub-components/Sidebar/Logo';
import ProfileNav from 'pub-components/Sidebar/ProfileNav';
import { Link } from 'react-router-dom';
import UilBars from '@iconscout/react-unicons/icons/uil-bars';
import useViewport from 'services/viewport-hook';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isAndroid } from 'react-device-detect';
import {
  selectLoadedScript,
  setScript
} from 'store/slices/script-load/scriptLoadSlice';
import { useState } from 'react';
import {
  getUserFromViewedUser,
  removeFromCookies,
  removeSupportBotCookies
} from 'services/utils/generic.methods';
import storage from 'services/utils/storage';
import config from 'config';
import { Alert } from '@material-ui/lab';
import { globalLogout } from 'services/utils/generic-logout-method';
import { selectRoles } from 'store/slices/roles/rolesSlice';
import { AppMetaProvider } from 'pub-components/Sidebar/helper';

const MainDivChatWidget = 'apexchat_prechat_invitation_wrapper';
const MainDivChatWindow = 'apexchat_dompopup_chatwindow_wrapper';
const IFramIdWidget = 'apexchat_prechat_invitation_frame';
const IFramIdChatBox = 'apexchat_dompopup_chatwindow_frame';
const classNameChatBoxCloseButton = 'livechat_close';
const ElementIdWidgetButton = 'apexchat_prechat_main_bg';
const ElementIdPreChat = 'apexchat_prechat_message_popup_container';

const useStyles = makeStyles(theme => ({
  topContainer: {
    background: 'white',
    padding: '10px',
    position: 'fixed',
    width: '100%',
    color: 'black',
    zIndex: '1041',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '70px',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.15)'
  },
  logoLink: {
    borderRadius: '10px'
  },
  topbarMenuContainer: { display: 'grid', gridAutoFlow: 'column', gap: '20px' },
  disabledLink: {
    pointerEvents: 'none'
  }
}));

const TopBar = ({
  showSidebar,
  setShowSidebar,
  limitedAccessModalHandler,
  showBanner
}) => {
  const classes = useStyles();
  const screen = useViewport();
  const dispatch = useDispatch();
  const { roles } = useSelector(selectRoles);
  const { scriptLoad } = useSelector(selectLoadedScript);
  const [showChat, setShowChat] = useState(false);
  const [, setLoginDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(storage.getItem('Profile'));
  const { isWhiteLabeled } = AppMetaProvider().GetStaticMeta();
  useEffect(() => {
    if (JSON.parse(scriptLoad) && window.navigator.onLine) {
      loadScriptFunc();
    }

    // UIUX-2154: removed is from cookies causing agentAliasId error on invitation script
    removeFromCookies(['livechat_agent_alias_id']);
  }, []);
  useEffect(() => {
    let loggedInUser = getUserFromViewedUser();
    if (loggedInUser) {
      setLoginDetails(loggedInUser);
    }
  }, [showChat]);
  const showWidget = () => {
    setShowChat(true);
    widgetVisibility(MainDivChatWidget, true);
    widgetVisibility(ElementIdWidgetButton, true);
    widgetVisibility(ElementIdPreChat, true);
  };

  const initializeChatCloseOnClick = () => {
    let iframeChat = document.getElementById(IFramIdChatBox);
    if (iframeChat) {
      let iframeDoc = (iframeChat.contentWindow || iframeChat.contentDocument)
        .document;
      let chatCloseButtons = iframeDoc.getElementsByClassName(
        classNameChatBoxCloseButton
      );
      if (chatCloseButtons.length) {
        chatCloseButtons[0].onclick = chatCloseFunction;
      }
    }
  };

  const loadScriptFunc = () => {
    dispatch(
      setScript({
        isLoaded: true,
        src: config.scriptBotLink
      })
    );
    showWidget();
    setLoading(true);
    let inter = setInterval(() => {
      console.log('connecting...');
      if (window.ApexChat) {
        initializeWidgetOnClick();
        setLoading(false);
        clearInterval(inter);
      } else if (!window.navigator.onLine) clearInterval(inter);
    }, 1000);
  };

  const chatCloseFunction = () => {
    widgetVisibility(ElementIdWidgetButton, false);
    widgetVisibility(ElementIdPreChat, false);
    setShowChat(false);
    storage.setItem('ScriptLoad', false);
    removeSupportBotCookies();
  };

  const initializeWidgetOnClick = () => {
    initializeChatCloseOnClick();
    let iframeWidget = document.getElementById(IFramIdWidget);
    if (iframeWidget) {
      let iframeDoc = (
        iframeWidget.contentWindow || iframeWidget.contentDocument
      ).document;
      let widgetButton = null;
      let inter2 = setInterval(() => {
        console.log('initializing...');
        widgetButton = iframeDoc.getElementById(ElementIdWidgetButton);
        if (widgetButton) {
          widgetButton.onclick = onWidgetClickFunction;
          clearInterval(inter2);
        } else if (!window.navigator.onLine) clearInterval(inter2);
      }, 1000);
    }
  };

  const onWidgetClickFunction = () => {
    setTimeout(() => {
      initializeChatCloseOnClick();
    }, 200);
  };

  const addScript = () => {
    if (!showChat) {
      if (scriptLoad) {
        initializeWidgetOnClick();
        showWidget();
        storage.setItem('ScriptLoad', true);
      } else if (window.navigator.onLine) {
        loadScriptFunc();
      }
    } else {
      setShowChat(false);
    }
  };
  const widgetVisibility = (id, condition) => {
    setTimeout(() => {
      let doc = document;
      if (!doc.getElementById(id)) {
        let iframeWidget = document.getElementById(IFramIdWidget);
        if (iframeWidget) {
          let iframeDoc = (
            iframeWidget.contentWindow || iframeWidget.contentDocument
          ).document;
          doc = iframeDoc;
        }
      }
      if (doc.getElementById(id))
        doc.getElementById(id).style.visibility = condition
          ? 'visible'
          : 'hidden';
    }, 50);
  };

  const onLogOutRemoveChat = () => {
    widgetVisibility(MainDivChatWindow, false);
    widgetVisibility(IFramIdChatBox, false);
    widgetVisibility(ElementIdPreChat, false);
    setShowChat(false);
  };
  return (
    <div
      className={classes.topContainer}
      style={showBanner ? { top: '59px' } : null}
    >
      {screen?.xs && (
        <UilBars
          size="30"
          color="var(--primary)"
          className="ml-2"
          onClick={() => setShowSidebar(!showSidebar)}
        />
      )}
      <Link
        className={`navbar-logo d-block`}
        to={roles?.home?.displayOnly ? null : '/home'}
        onClick={roles?.home?.displayOnly ? limitedAccessModalHandler : null}
      >
        <Logo />
      </Link>
      <div className={`align-items-center ${classes.topbarMenuContainer}`}>
        {roles?.showLimitedAccessWarning && (
          <Alert severity="warning">
            Limited access. Please{' '}
            <Link style={{ color: 'red' }} onClick={() => globalLogout()}>
              Log In
            </Link>{' '}
            to get full access
          </Alert>
        )}

        {!roles?.showLimitedAccessWarning && (
          <HelpComp
            loading={loading}
            addScript={addScript}
            setShowSidebar={setShowSidebar}
          />
        )}
        <ProfileNav
          showSideBar={false}
          onLogOutRemoveChat={onLogOutRemoveChat}
        />
      </div>
    </div>
  );
};

export default TopBar;
